package com.eladfinish.bible.contest.ui.components.toolbar.model

enum class ToolbarKind {
    None,
    Main,
    Browse,
    ChapterContent,
    MultipleChoice,
    CompleteVerse,
    Mikud,
    Search,
    PairMatching,
    Pyramid,
    OpenQuestions,
    RandomVerse,
}
